<script>
    import { lang } from "../scripts/stores";

    export let chartType;
    
    //turn valuen mukaisessa järjestyksessä
    let colors = ["rgb(255, 51, 51)", "rgb(255, 170, 51)", "rgb(255, 235, 0)", "rgb(0, 204, 102)"];
    let texts_fi = ["Merkittävästi aistikuormaa", "Paljon aistikuormaa", "Hieman aistikuormaa", "Vähäinen aistikuorma"];
    let texts_en = ["Substantial sensory load", "Plenty of sensory load", "Some sensory load", "Little sonsory load"];

    let texts = $lang === "fi" ? texts_fi : texts_en;

    $: if($lang) texts = $lang === "fi" ? texts_fi : texts_en;

    if(chartType === "normal") {
        colors = colors.reverse();
        texts = texts.reverse();
    }
</script>

<style>
    .category-labels {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        margin: 2rem auto;
        max-width: 640px;
    }
    .category-label {
        width: fit-content;
        display: flex;
        align-items: center;
        margin-right: .5rem;
        margin-bottom: .7rem;
        font-size: 14px;
    }
    .category-color {
        width: 1rem;
        height: 1rem;
        margin-right: .5rem;
    }

    @media only screen and (max-width: 600px) {
        .category-labels {
            justify-content: space-evenly;
        }
    }
</style>

<div class="category-labels">
    {#each colors as color, i}
        <div class="category-label">
            <div class="category-color" style="background: {color}"></div>
            <span>{ texts[i] }</span>
        </div>    
    {/each}
</div>